import { Button } from "react-bootstrap";
import { getUserCookie } from "../../../utils/cookiesUtils";
import { buttonText } from "../../../utils/buttonText";

function MainPage(props) {
  const { goToCopyPathPage, goToLocalPage } = props;

  const userData = getUserCookie();
  const role = userData ? userData.role : null;

  return (
    <div>
      {role !== "annotator" && (
        <Button onClick={goToCopyPathPage}>{buttonText("Copy Data Path")}</Button>
      )}
      <Button onClick={goToLocalPage}>{buttonText("Local")}</Button>
    </div>
  );
}

export default MainPage;
